import { Form } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { URL_BACKEND } from "../../api/url";
import { elToast } from "../../functions/alertas";

export const useEditarBachillerato = () => {

    const [form] = Form.useForm()
    const { id:pk_bachillerato } = useParams();
    const [valoresForm, setValoresForm] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [opcionesLocalidades, setOpcionesLocalidades] = useState([])
    
    const traerBachillerato = () => {

        if (pk_bachillerato) {
            
            let d = new FormData()
            d.append('funcion', 'traerBachillerato')
            d.append('pk_bachillerato', pk_bachillerato)

            fetch( URL_BACKEND, {
                method: 'post',
                body: d
            })
            .then( r => r.json() )
            .then( function( e ) {

                setValoresForm({
                    pk_bachillerato: e[0].pk_bachillerato,
                    nom_bachillerato: e[0].nom_bachillerato,
                    localidad: e[0].localidad
                })
            })
            .catch( console.log )
        }
    }

    const traerLocalidades = () => {

        if (pk_bachillerato) {
            
            let d = new FormData()
            d.append('funcion', 'traerLocalidadesAutocomplete')

            fetch( URL_BACKEND, {
                method: 'post',
                body: d
            })
            .then( r => r.json() )
            .then( function( e ) {

                setOpcionesLocalidades(e)
            })
            .catch( () => alert("Error en el servidor") )
        }
    }

    const onFinish = (values) => {

        values.funcion = 'actualizarBachillerato'
        values.pk_bachillerato = valoresForm.pk_bachillerato
        fetch( URL_BACKEND, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        })
        .then( res => res.json())
        .then( function(d) {
            console.log("d", d);

            setIsLoading(false)

            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
    };

    // useEffects
    useEffect(() => {
        
        traerBachillerato()
        traerLocalidades()
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        form.setFieldsValue( valoresForm )
    }, [ valoresForm ])
    

    return {
        onFinish,
        valoresForm,
        form,
        isLoading,
        opcionesLocalidades
    }
}
